// 对话数据
import { getTreatmentDayitemNext, dayitemStepsubmit, getTreatmentDayitem, sendMsg } from '@/api/dialogue'
import { Dialog } from 'vant';
import Router from '@/router'
export default {
  state: {
    taskDialogueList: [] // 子任务 对话列表 通用
  },
  getters: {
  },
  mutations: {
    // 设置list
    setTaskDialogueList(state, payload) {
      state.taskDialogueList = payload
    }
  },
  actions: {
    // 获取子任务历史
    async getTreatmentDayitem({ commit, dispatch, rootState }, payload) {
      try {
        const resData = await getTreatmentDayitem(payload);
        let useData = resData.filter(item => !!item.message).map(item => {
          const itemData = JSON.parse(item.message)
          if(itemData.type === 'ChatSend') {
            return itemData;
          }
          if(itemData.step_type === 'SYS_INFO') {
            Dialog({
              message: itemData.step_data.content
            }).then(() => {
              Router.back()
            });
            return;
          }
          return {
            ...itemData,
            id: payload.id,
            step_id: itemData.step_id,
            instance_id: itemData.step_data.instance_id,
            type: rootState.itemTypeList[itemData.step_type],
            item_type: itemData.step_type,
            text: itemData.step_data.content || '',
            confirmTxt: itemData.step_data.confirm || '',
            cancelTxt: itemData.step_data.cancel || '',
            cardMode: 'dialogue',
            isShowTime: true
          }
        });
        commit('setTaskDialogueList', useData);
        if(useData.length === 0) {
          dispatch('getTreatmentDayitemNext', payload)
        }
        return useData;
      } catch (error) {
        console.log(error)
        return false;
      }
    },
    // 获取子任务下一项内容
    async getTreatmentDayitemNext({ state, commit, rootState }, payload) {
      try {
        const resData = await getTreatmentDayitemNext(payload);
        if(resData.step_type === 'SYS_INFO') {
          Dialog({
            message: resData.step_data.content
          }).then(() => {
            Router.back()
          });
          return;
        }
        let useList = [];
        useList = [
          ...state.taskDialogueList,
          {
            ...resData,
            id: payload.id,
            step_id: resData.step_id,
            instance_id: resData.step_data.instance_id,
            type: rootState.itemTypeList[resData.step_type],
            item_type: resData.step_type,
            text: resData.step_data.content || '',
            confirmTxt: resData.step_data.confirm || '',
            cancelTxt: resData.step_data.cancel || '',
            cardMode: 'dialogue',
            isShowTime: true
          }
        ];
        commit('setTaskDialogueList', useList);
        return resData
      } catch (error) {
        console.log(error)
        return false;
      }
    },

    // 子任务提交
    async dayitemStepsubmit(_, payload) {
      try {
        const resData = await dayitemStepsubmit(payload);
        console.log(resData);
        return resData;
      } catch (error) {
        throw new Error(error.data.msg);
      }
    },

    // 消息发送记录
    async sednMsg({ state, commit }, payload) {
      try {
        console.log(payload)
        const resData = await sendMsg(payload);
        const useList = [
          ...state.taskDialogueList,
          payload
        ]
        commit('setTaskDialogueList', useList);
        return resData;
      } catch (error) {
        console.log(error)
        return false;
      }
    },
  }
}
